import { Validator } from 'fluentvalidation-ts';
import { beAnInteger, beValidPercentage, haveDecimalPlaces } from '../../../../../validators/stringValidators';
import { FloorLevelCode } from '../../quoteOrDesignFormData';
import { UnitFormModel } from '../../units/unitFormModel';
import { DownlossTypeCode } from './downlossTypeCode';
import {
  defaultTemperatureBelowInDegreesCelsiusByDownlossTypeCode,
  getRoomPositionalHeatingDefaults,
} from './roomHeatLossDefaults';

export type RoomFloorHeatLossDetailsFormModel = {
  roomAreaPercentage: string;
  downlossTypeCode: DownlossTypeCode;
  temperatureBelowInDegreesCelsius: string;
};

export const getNewRoomFloorHeatLossDetailsFormModel = (
  roomFloorLevelCode: FloorLevelCode | null,
  externalAirTemperatureInDegreesCelsius: number,
  unit: UnitFormModel,
): RoomFloorHeatLossDetailsFormModel => {
  const downlossTypeCode = getRoomPositionalHeatingDefaults(
    roomFloorLevelCode,
    externalAirTemperatureInDegreesCelsius,
    unit,
  ).downlossTypeCode;

  return {
    roomAreaPercentage: '0',
    downlossTypeCode,
    temperatureBelowInDegreesCelsius: defaultTemperatureBelowInDegreesCelsiusByDownlossTypeCode[
      downlossTypeCode
    ].toString(),
  };
};

export const getDefaultRoomFloorHeatLossDetailsFormModel = (
  downlossTypeCode: DownlossTypeCode,
): RoomFloorHeatLossDetailsFormModel => ({
  roomAreaPercentage: '0',
  downlossTypeCode: downlossTypeCode,
  temperatureBelowInDegreesCelsius: defaultTemperatureBelowInDegreesCelsiusByDownlossTypeCode[
    downlossTypeCode
  ].toString(),
});

export class RoomFloorHeatLossDetailsFormModelValidator extends Validator<RoomFloorHeatLossDetailsFormModel> {
  constructor(totalRoomAreaPercentageAcrossAllFloorElements: number, heatLossDetailsAreRequired: boolean) {
    super();

    this.ruleFor('roomAreaPercentage')
      .must(beAnInteger)
      .must(beValidPercentage);

    this.ruleFor('roomAreaPercentage')
      .notEmpty()
      .must(() => totalRoomAreaPercentageAcrossAllFloorElements === 100)
      .when(() => heatLossDetailsAreRequired);

    this.ruleFor('downlossTypeCode').notEmpty();

    this.ruleFor('temperatureBelowInDegreesCelsius').must(haveDecimalPlaces(1));

    this.ruleFor('temperatureBelowInDegreesCelsius')
      .notEmpty()
      .when(model => heatLossDetailsAreRequired && Number(model.roomAreaPercentage) !== 0);
  }
}
